<py-modal
  [actions]="templateActions"
  [showCancelButton]="true"
  [title]="'shoppingLists.deleteList_title' | cxTranslate"
  [error]="error$ | async"
  [errorText]="'shoppingLists.deleteListError_text' | cxTranslate"
  [centered]="true"
  [size]="'sm'"
  [scrollable]="true"
  [cxFocus]="focusConfig"
  (esc)="closeModal('escape pressed')"
>
  {{ 'shoppingLists.deleteListConfirmation_text' | cxTranslate : { shoppingListName: shoppingListName } }}
</py-modal>

<ng-template #templateActions>
  <py-action-button
    [buttonClass]="'w-100 btn btn-danger'"
    [type]="'button'"
    (click)="onDelete()"
    [loading]="loading$ | async"
    [buttonLabel]="'common.delete_action' | cxTranslate"
  >
  </py-action-button>
</ng-template>
